import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    computed,
    effect,
    inject,
    OnInit,
    signal,
    ViewChild
} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {MatIcon, MatIconRegistry} from '@angular/material/icon';
import {MatFormField, MatInput, MatSuffix} from '@angular/material/input';
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from '@angular/material/sidenav';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {RegisterHeaderComponent} from '../register/register-header/register-header.component';
import {SideBarDoubleComponent} from '../../../shared/components/side-bar-double/side-bar-double.component';
import { GradeDetailsDto, GradeService, OrganizationService, ReferenceService } from '../../apiModule1';
import { catchError, combineLatest, filter, firstValueFrom, Observable, of, switchMap, take, tap, finalize } from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import 'moment/locale/ru';
import {quarters, years} from '../index-ias/filter-dialog/filter-dialog.component';
import moment from 'moment';
import {GradeFillFormComponent} from './grade-fill-form/grade-fill-form.component';
import {DomSanitizer} from '@angular/platform-browser';
import icons from './icons';
import {CurrentUserService} from '../../../core/services/user.service';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {DialogDeleteComponent} from '../index-entity/dialogForDelete/dialog-delete.component';
import {MatDialog} from '@angular/material/dialog';
import {CommunicationService} from '../../../core/services/communication.service';
import {ExperimentComponent} from '../../../shared/components/experiment/experiment.component';
import {StatusSelectComponent} from './status-select/status-select.component';
import {AccessRoleDirective} from './access-role.directive';
import {AccessGradeControlsService} from './access-controls.service';
import {YesNoComponent} from './yes-no/yes-no.component';
import dataJson from "./data.json"
import {toObservable} from '@angular/core/rxjs-interop';
import {MatSnackBarRef} from "@angular/material/snack-bar";
import { ToastComponent } from "../../../shared/components/toast/toast.component";
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export interface ChangeGradeStatusRequest {
    statusId: number,
    comment: string,
    date: string
}

export interface GradeControlButtons {
    title: string,
    name: AccessableControlKeys,
    blue?: boolean,
    red?: boolean,
    event: Function,
    blockator?: () => boolean
}

@Component({
    selector: 'pas-create-grade',
    standalone: true,
    imports: [
        MatIcon,
        MatInput,
        MatSidenav,
        MatSidenavContainer,
        MatSidenavContent,
        ReactiveFormsModule,
        RegisterHeaderComponent,
        SideBarDoubleComponent,
        AsyncPipe,
        MatFormField,
        MatSuffix,
        MatDatepicker,
        MatDatepickerInput,
        MatDatepickerToggle,
        GradeFillFormComponent,
        ExperimentComponent,
        AccessRoleDirective,

    ],
    templateUrl: './create-grade.component.html',
    styleUrls: ['./create-grade.component.scss', '../index-entity/index-entity.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
        {provide: CreateGradeComponent}
    ]
})
export class CreateGradeComponent implements OnInit {

    @ViewChild(GradeFillFormComponent) gradeFillFormComponent: GradeFillFormComponent | null = null;
    mobileOpen: boolean = false;
    opened: boolean = true;

    cdr = inject(ChangeDetectorRef)
    currentUserService = inject(CurrentUserService)
    currentUser = signal< User | null>( null);


    isAdmin=computed(()=> {
        if (this.currentUser()) {
            return this.currentUser()?.roles?.map(e => e.code.toLowerCase()).includes('admin')
        } else {
            return false
        }
    })

    isExpert = computed(()=> {
        if (this.currentUser) {
            return this.currentUser()?.roles?.map(e => e.code.toLowerCase()).includes('expert')
        } else {
            return false
        }
    })

    isOrganization = computed(()=> {
        if (this.currentUser()) {
            return this.currentUser()?.roles?.map(e => e.code.toLowerCase()).includes('organization')
        } else {
            return false
        }
    })
    isDepartment = computed(()=> {
        if (this.currentUser()) {
            return this.currentUser()?.roles?.map(e => e.code.toLowerCase()).includes('department')
        } else {
            return false
        }
    })

    dialog: MatDialog = inject(MatDialog);
    toastService = inject(CommunicationService);
    iconRegistry: MatIconRegistry = inject(MatIconRegistry);
    sanitizer: DomSanitizer = inject(DomSanitizer);

    gradeService = inject(GradeService);
    http = inject(HttpClient);
    isUploadingExcel = false;
    accessService = inject(AccessGradeControlsService)

    structuredCommon$: Observable<any> | null = null;
    grade = signal<Grade | null>(null);

    canCheckboxView = computed(() => {
        const grade = this.grade();
        if (this.isNew) {
            return this.currentUser()?.rights.view.need_check_analytic_checkbox
        }
        return !!grade?.rights.view.need_check_analytic_checkbox
    })
    canCheckboxEdit = computed(() => {
        const grade = this.grade();
        if (this.isNew) {
            return this.currentUser()?.rights.edit.need_check_analytic_checkbox
        }
        return !!grade?.rights.edit.need_check_analytic_checkbox
    })
    canEmailView = computed(() => !!this.grade() && this.grade()?.rights?.view?.sent_grade_email)
    canUploadValues = computed(() => {
        const rights = this.grade()?.rights;

        return !this.isNew
            && rights?.view?.['upload_values'] === true
            && rights?.edit?.['upload_values'] === true;
    });
    canEmailClick = computed(() => !!this.grade() && this.grade()?.rights?.edit?.sent_grade_email)
    wasEmailSent = computed(() => !!this.grade() && this.grade()?.mailSent || false) ////Флаг повтороной отправки email, приходящий с сервера
    wasEmailSentSession = signal<boolean>(false); //Флаг повтороной отправки email, для блокировки повтороной отправки

    gradeStatus: GradeStatus | null = null;
    fullFilled = signal<boolean>(false);
    structuredObject = signal<ItemInGrade[]>([]);
    structuredObject0 = computed(() => {
        return this.structuredObject()[0]
    })
    structuredObject$ = toObservable(this.structuredObject)
    structuredObject0$ = toObservable(this.structuredObject0)

    public isNew: boolean = true;
    stage: Stage = 'create'
    mode = signal<'view' | 'edit'>('view')
    enterData = signal(true);
    isAppling = signal<boolean>(false);
    isGettingExcelFile = false;

    alreadyExists = signal<boolean>(false);
    toastRef: MatSnackBarRef<ToastComponent> | null = null;

    get mapedStructuredObject() {
        return this.structuredObject().map(e => e.entity.name)
    }

    //--- УЧРЕЖДЕНИЯ ---
    organizationService = inject(OrganizationService);
    organizations$: Observable<Organization[]> = this.organizationService.apiOrganizationGet({
        pageSize: 1e6,
        statusIds: [1]
    })
        .pipe(map(v => v.values));
    filteredOrganizations$: Observable<Organization[]> = of([]);
    filteredObject$: Observable<ItemInGrade[] | null> = of(null);

    //--- Тип оценки ---
    referenceService = inject(ReferenceService);
    periods$: Observable<CriterionPeriod[]> = this.referenceService.apiReferencePeriodsGet()
        .pipe(map(v => v.values));

    //--- Годы ---
    years = years
    quarters = quarters

    fb = inject(FormBuilder)
    formParams = this.fb.group({
        organization: this.fb.control<Organization | null>(null, [Validators.required]),
        createAt: this.fb.control<string | null>(null),
        comment: [''],
        period: this.fb.control<CriterionPeriod | null>(null, [Validators.required]),
        year: this.fb.control<IdName | null>(null, [Validators.required]),
        quarter: this.fb.control<IdName | null>(null),
    })

    formValue = this.fb.group({
        object: this.fb.control<ItemInGrade | null>(null, [Validators.required]),
    })

    get currentObject() {
        return this.formValue.get('object')!.value;
    }

    get period(): CriterionPeriod | null {
        return this.formParams.get('period')!.value;
    }

    set period(v: CriterionPeriod | null) {
        this.formParams.get('period')!.setValue(v);
    }

    get year(): IdName | null {
        return this.formParams.get('year')!.value;
    }

    set year(v) {
        this.formParams.get('year')!.setValue(v);
    }

    get quarter(): IdName | null {
        return this.formParams.get('quarter')!.value;
    }

    set quarter(v) {
        this.formParams.get('quarter')!.setValue(v);
    }

    get createAt() {
        return this.formParams.get('createAt');
    }

    get organization(): string {
        return this.formParams.get('organization')!.value?.name || '';
    }

    get objectControl() {
        return this.formValue.get('object')
    }

    constructor(private route: ActivatedRoute, private router: Router) {
        icons.forEach(e => {
            this.iconRegistry.addSvgIcon(
                e.name,
                this.sanitizer.bypassSecurityTrustResourceUrl(e.href)
            );
        })
        this.currentUserService.user.subscribe(v => {
            this.currentUser.set(v);
        })

        effect(() => {
            const alreadyExists = this.alreadyExists();
            if (alreadyExists) {
                this.toastRef = this.toastService.abortable('Оценка с такими параметрами уже существует')
            } else {
                if (this.toastRef === null) return;
                this.toastRef.dismiss();
            }
        });

    }

    displayObject(v: ItemInGrade) {
        return v ? v.entity.name : '';
    }


    onClickOutside(): void {
    }

    onCreateNew(): void {
    }


    setFormData(data: Data) {
        this.isNew = false;
        const {organization, createAt, comment, period, year, quarter, value} = data as Grade
        this.grade.set(data as Grade);
        this.gradeStatus = this.grade()?.['gradeStatus'] ?? null;
        this.stage = this.grade()?.['gradeStatus']['code'] as Stage
        this.accessService.rights = this.grade()?.['rights'] ?? {} as ControlRights
        //--- заполняем форму ---
        this.formParams.get('organization')!.setValue(organization, {emitEvent: false});
        this.formParams.get('createAt')!.setValue(createAt, {emitEvent: false});
        this.formParams.get('comment')!.setValue(comment, {emitEvent: false});
        this.formParams.get('period')!.setValue(period, {emitEvent: false});

        const receivedYear = years.find(e => e.name === year + '')
        receivedYear && this.formParams.get('year')!.setValue(receivedYear, {emitEvent: false});

        const receivedQuarter = quarters.find(e => e.name === quarter + '')
        receivedQuarter && this.formParams.get('quarter')!.setValue(receivedQuarter, {emitEvent: false});

        this.structuredObject.set(value);
        this.formParams.updateValueAndValidity();
    }

    initFormDate() {
        this.route.data.subscribe((data: Data) => {
            if (!('data' in data)) {
                this.isNew = true;
                this.stage = 'create';
                this.mode.set('edit');
                this.accessService.rights = {
                    view: initialRightsToCreateGrade,
                    edit: initialRightsToCreateGrade
                } as ControlRights

                const setRightIfRoleIsOrganization = (role: boolean) => {
                    if (role) {
                        this.accessService.rights && (this.accessService.rights = {
                            ...this.accessService.rights,
                            view: {...this.accessService.rights.view, organization: true},
                            edit: {...this.accessService.rights.edit, organization: false}
                        })

                    }
                }

                this.currentUserService.user.subscribe(v => {
                    if (!v || !v.roles) return;
                    this.currentUser.set(v as User);
                    //--- если создаем новую оценку и у залогиненного юзера есть орнанизация, то заполняем ее ---
                    if ('organization' in v && v.organization !== null) this.formParams.get('organization')!.setValue(v.organization, {emitEvent: false});
                    const role = !!v.roles.find((e: Role) => e.code === 'organization');
                    setRightIfRoleIsOrganization(role);

                    if (this.isNew && (this.isDepartment() || this.isOrganization())) {
                        this.formParams.get('createAt')?.setValue(new Date().toISOString().split('T')[0]);
                    }

                    // this.cdr.detectChanges()
                })

                const {roles} = this.currentUserService.user$.value
                if (!roles) return;
                const role = !!roles.find((e: Role) => e.code === 'organization');
                setRightIfRoleIsOrganization(role);

                return;
            }

            this.setFormData(data['data'])
        })
    }

    ngOnInit(): void {
        //--- поиск по индексу ---
        this.filteredObject$ = this.formValue.get('object')!.valueChanges
            .pipe(startWith(' '))
            .pipe(map(str => !!str && this.structuredObject() && this.structuredObject().filter((e: ItemInGrade) => {
                        if (typeof str !== 'string') return false;
                        return e.entity.name.toLowerCase().includes((str as String).toLowerCase());
                    }) || this.structuredObject()
                )
            )

        //--- отслеживание изменения в currentObject и формирование флага заполненности индексов ---
        const isFullFilled = () => {
            const res = this.structuredObject()
                .filter(e => e.needCheckAnalytic)
                .flatMap(e => e.indexValues.map(i => (i.value !== undefined && i.value !== null) || i.valueItem))
                .every(v => v !== undefined && v !== null)
            return res;

        }

        this.fullFilled.set(isFullFilled());
        this.formValue.get('object')!.valueChanges.subscribe((v: ItemInGrade | null) => {
            console.log('this.formValue.get(\'object\')', v, this.structuredObject()
                .map(e => e.indexValues.map(i => i.value || i.valueItem))
            )
            this.fullFilled.set(isFullFilled());

        })

        this.structuredCommon$ = this.formParams.statusChanges
            .pipe(tap(v => {
                console.log('formParams.statusChanges', v)
            }))
            .pipe(
                filter(v => v === 'VALID'),
                switchMap(() => {
                    if (true) {
                        return this.gradeService
                            .apiGradeStructurePost({apiGradePostRequest: convertFormToSend(this.formParams)})
                            .pipe(catchError((err: HttpErrorResponse) => {
                                console.info('error', err.error);
                                if (err.status === 409) {
                                    this.alreadyExists.set(true)
                                } else {
                                    this.alreadyExists.set(false)
                                }
                                // err.status === 409 && this.toastService.error('Оценка с такими параметрами уже существует');
                                this.formValue.get('object')!.setValue(null);
                                this.structuredObject.set([]);
                                this.cdr.markForCheck();
                                return of(null)
                            }))
                    } else {
                        return of(dataJson)
                    }
                })
            )
            .pipe(tap(v => {
                console.log('gradeService.apiGradeStructurePost', v)
                if (v !== null) this.alreadyExists.set(false)
                if (!v || !v.length) {
                    this.formValue.get('object')!.setValue(null);
                    this.structuredObject.set([]);
                }
                this.cdr.markForCheck();
            }));

        !this.route.snapshot.params['id'] && this.structuredCommon$.subscribe((v: Grade) => {
            if (!v) return;
            this.grade.set(v)
            this.structuredObject.set(v.value);
            this.structuredObject().length && this.formValue.get('object')!.setValue(this.structuredObject()[0]);
            if (v) {
                this.accessService.rights && (this.accessService.rights = {
                    ...this.accessService.rights,
                    edit: {...this.accessService.rights.edit, save: true}
                });
            }
        })


        this.formParams.get('period')!.valueChanges.subscribe((v: CriterionPeriod | null) => {
            if (v?.name === 'Квартальная') {
                this.formParams.get('quarter')!.setValidators([Validators.required]);
            } else {
                this.formParams.get('quarter')!.clearValidators();
            }
            this.formParams.get('quarter')!.updateValueAndValidity();
        });

        this.filteredOrganizations$ = combineLatest([
            this.organizations$,
            this.formParams.get('organization')!.valueChanges.pipe(startWith(''))
        ])
            .pipe(
                map(([items, searchTerm]) =>
                        items && items.length && items.filter(item =>
                            item.name.toLowerCase().includes(searchTerm as string || ''.toLowerCase())
                        ) || []
                )
            );

        this.formValue.get('object')!.valueChanges.subscribe(v => {
            console.log('formValue', v)
        })

        this.structuredObject$.subscribe(v => {
            console.log(v)
            v && this.formValue.get('object')!.setValue(v[0]);
        })
        this.structuredObject0$.subscribe(v => {
            console.log(v)
        })


        this.initFormDate()
    }

    apply() {
        this.isAppling.set(true);
        // this.saveButtonTitle.set(this._saveButtonTitleInProgress);

        const yearControl = this.formParams.get('year');
        const year = yearControl && yearControl.value && yearControl.value.name;
        const yearValue: number | null = Number(year) || null;

        const quarterControl = this.formParams.get('quarter');
        const quarter = quarterControl && quarterControl.value && quarterControl.value.name;
        const quarterValue: number | null = Number(quarter) || null;

        const res: Partial<Grade> = {
            ...this.grade(),
            organization: this.formParams.get('organization')!.value || this.grade()?.organization,
            createAt: this.formParams.get('createAt')!.value || this.grade()?.createAt,
            comment: this.formParams.get('comment')!.value || this.grade()?.comment,
            period: this.formParams.get('period')!.value || this.grade()?.period,
            year: yearValue || this.grade()?.year,
            quarter: quarterValue || this.grade()?.quarter || undefined,

        };

        const id = this.route.snapshot.params['id']
        const method = id !== undefined ? 'apiGradeIdPut' : 'apiGradePost'
        this.gradeFillFormComponent && this.gradeService[method]({
            id,
            apiGradePostRequest: res as any
        })
            .pipe(take(1))
            .subscribe(
                {
                    next: v => {
                        this.toastService.info(`Оценка №${v.id} успешно сохранена`)
                        this.mode.set('view')
                        this.isAppling.set(false);
                        this.router.navigateByUrl(`/grade/${v.id}`)
                    },
                    error: _ => {
                        this.toastService.error(`Ошибка при сохранении оценки. Попробуйте еще раз`)
                        this.isAppling.set(false);
                    },
                }
            )
    }

    isFilled(i: ItemInGrade | undefined | null) {
        if (!i) return;
        if (typeof i !== 'object') return;
        return i.indexValues.every(e => (e.value !== undefined && e.value !== null) || e.valueItem)
    }

    async onClose(): Promise<void> {
        await this.router.navigateByUrl('/grade')
    }

    async onCopyURL(): Promise<void> {
        await window.navigator.clipboard.writeText(window.location.href)
    }

    onArchive(): void {

        const dialogRef = this.dialog.open(DialogDeleteComponent, {
            width: '30vw',
            data: {id: this.route.snapshot.params['id']},
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (!result) return;
            const id = result['id']
            this.gradeService.apiGradeSetstatusIdPut({id, apiCriterionSetstatusIdPutRequest: result})
                .subscribe((v) => {
                    console.log('archived', v)
                    this.toastService.info(`Оценка №${v.id} успешно архивирована`)
                });
        });

    }

    sendChangeStatusRequest(request: ChangeGradeStatusRequest): void {
        this.gradeService.apiGradeSetgradestatusIdPut({
            id: this.route.snapshot.params['id'],
            apiCriterionSetstatusIdPutRequest: request
        })
            .subscribe((result) => {
                this.gradeStatus = result.gradeStatus;
                this.setFormData(result)
                this.cdr.detectChanges();
            })
    }

    onStatusSelect() {
        this.dialog.open(StatusSelectComponent, {
            width: 'min(490px,100%)',
            data: this.gradeStatus,
        }).afterClosed().subscribe(v => {
            if (!v) return;
            const request: ChangeGradeStatusRequest = {
                statusId: v.id,
                comment: "",
                date: new Date().toISOString()
            }
            this.sendChangeStatusRequest(request)
        })
    }

    private readonly stageTitles: Record<Stage, string> = {
        to_approval: 'Вы действительно хотите отправить оценку на согласование Эксперту?',
        agreed: 'Вы действительно хотите согласовать  оценку?',
        not_agreed: 'Вы действительно хотите отправить оценку на доработку?',
        create: '',
        project: '',
        approved: 'Вы действительно хотите утвердить оценку? '
    }

    async changeStageTo(code: Stage) {
        // const code: Stage = 'to_approval'
        try {
            const status: GradeStatus = await firstValueFrom(this.referenceService.apiReferenceGradestatusesByfilterGet({code}))
            this.dialog.open(YesNoComponent, {
                width: 'min(490px,100%)',
                data: {
                    title: this.stageTitles[code],
                }
            }).afterClosed().subscribe(v => {
                if (!v) return
                const requset: ChangeGradeStatusRequest = {
                    statusId: status.id,
                    comment: "",
                    date: new Date().toISOString()
                }
                this.sendChangeStatusRequest(requset)
            })
        } catch (_) {
            this.toastService.error('Ошибка связи с сервером')
        }
    }

    private readonly _saveButtonTitleInitial = 'Сохранить'
    private readonly _saveButtonTitleInProgress = 'Сохраняем...'
    saveButtonTitle = signal(this._saveButtonTitleInitial)

    controlButtons = computed<GradeControlButtons[]>(() => [
        {title: 'Редактировать', name: 'edit', event: () => this.mode.set('edit')},
        {title: this.saveButtonTitle(), name: 'save', blue: true, event: () => this.apply()},
        {
            title: 'Отправить на согласование ',
            blue: true,
            name: 'send_approval',
            event: () => this.onCliskSendApproval(),
            blockator: computed(() => this.fullFilled())
        },
        {
            title: 'Не согласовано', name: 'not_agreed', red: true, event: () => this.changeStageTo('not_agreed')
        },
        {
            title: 'Согласовано', name: 'agreed', blue: true, event: () => this.changeStageTo('agreed')
        },
    ] as GradeControlButtons[])

    private async onCliskSendApproval(): Promise<void> {
        if (!this.fullFilled()) {
            return this.toastService.error('Не все индексы заполнены');
        }
        await this.changeStageTo('to_approval');
    }

    onEnterData($event: number) {
        this.enterData.set(!$event)
    }

    onUploadExcel(file: File): void {
        const gradeId = this.grade()?.id;
        if (!gradeId || !this.canUploadValues() || this.isUploadingExcel) return;

        const formData = new FormData();
        formData.append('file', file);
        this.isUploadingExcel = true;

        this.http.post<Grade>(`${environment.api_url}/api/grade/${gradeId}/upload`, formData)
            .pipe(
                take(1),
                finalize(() => {
                    this.isUploadingExcel = false;
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: updatedGrade => {
                    this.setFormData(updatedGrade);
                    this.toastService.sucess('Данные загружены');
                },
                error: (error: HttpErrorResponse) => {
                    this.toastService.error(error.error?.detail || error.error?.message || 'Ошибка загрузки');
                }
            });
    }

    onExportExcel(data: any) {
        console.log('onExportExcel', data)
        this.isGettingExcelFile = true;


        const yearControl = this.formParams.get('year');
        const year = yearControl && yearControl.value && yearControl.value.name;
        const yearValue: number | null = Number(year) || null;

        const quarterControl = this.formParams.get('quarter');
        const quarter = quarterControl && quarterControl.value && quarterControl.value.name;
        const quarterValue: number | null = Number(quarter) || null;

        const res: Partial<Grade> = {
            ...this.grade,
            organization: this.formParams.get('organization')!.value || this.grade()?.organization,
            createAt: this.formParams.get('createAt')!.value || this.grade()?.createAt,
            comment: this.formParams.get('comment')!.value || this.grade()?.comment,
            period: this.formParams.get('period')!.value || this.grade()?.period,
            year: yearValue || this.grade()?.year,
            quarter: quarterValue || this.grade()?.quarter || undefined,
            value: this.structuredObject()
        };

        this.gradeService.apiGradeFileBymodelPost({apiGradePostRequest: res as any}, "body", false, {httpHeaderAccept: '*/*'})
            .subscribe((res: Blob) => {
                const url = window.URL.createObjectURL(res);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.xlsx');
                this.isGettingExcelFile = false;
                this.cdr.markForCheck();
                link.click();
                window.URL.revokeObjectURL(url);
            })
    }

    onNoViolations() {
        const doUpdate = (v: any) => {
            if (!v || !v?.value[0]) return v;
            const updated = {...v};

            updated.value[0].indexValues.forEach((e: IndexValue) => {
                const noViolations = e.index.indexItems?.find(e => e.noViolations === true)
                if (!noViolations) return
                e.valueItem = noViolations || e.valueItem
            })
            return updated;
        }
        this.grade() && (this.grade.update(doUpdate))
        const val = {...this.grade()!.value[0]};
        this.structuredObject.set([val])
    }

    protected onCheckAnalytic(item: any, $event: MouseEvent) {
        // $event.preventDefault();
        $event.stopPropagation();
        if (this.mode() !== 'edit') return;
        const {roles} = this.currentUserService.user$.value
        const availableRoles = roles.map(e => e.code.toLowerCase())

        if (!availableRoles.includes('admin') && !availableRoles.includes('expert')) {
            this.toastService.error(
                'У вас нет прав для изменения данного параметра'
            )
            return
        }
        item['needCheckAnalytic'] = !item['needCheckAnalytic'] || false;
        // this.cdr.detectChanges()
    }

    protected onEmail() {
        if (!this.canEmailView()) return
        if (this.wasEmailSentSession()) {
            return this.toastService.info('Запрос на отправку письма уже был отправлен')
        } else {
            this.wasEmailSentSession.set(true)
        }
        if (!this.grade() || !this.grade()?.id) return
        try {
            this.grade()?.id && this.gradeService.email(this.grade()!.id).subscribe(v => {
                this.toastService.info('Письмо успешно отправлено')
                this.wasEmailSentSession.set(false)
            })
        } catch (e) {
            this.toastService.error(
                'Ошибка при отправке письма'
            )
        }
    }
}

export const convertFormToSend = (form: FormGroup): GradeDetailsDto => {
    const res: GradeDetailsDto = {
        organization: form.get('organization')!.value,
        createAt: moment(form.get('createAt')!.value || new Date().toISOString()).format('YYYY-MM-DDTHH:mm:ss'),
        comment: form.get('comment')!.value,
        period: form.get('period')!.value,
        year: form.get('year')!.value?.name || null,
        quarter: +form.get('quarter')!.value?.name || 0,
    }
    return res
}

export function isFilled<T extends Record<string, any>>(arr: T[], arrFields: (keyof T)[]): boolean {
    if (!arr || !arr.length) return false;
    if (!arrFields) return false;
    return arr.every(e => arrFields.every(f => e[f]));
}

export const initialRightsToCreateGrade = {
    date: true,
    period: true,
    year: true,
    quarter: true,
    organization: true,
    org_facility_indices: true,
    archive: false,
    status: false,
    grade_comment: true,
    enter_data: true,
    index_comment: true,
    indicator_indices: true
} as AccessableControls


